/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import { PContract } from './useUserContractsPagination';
import { ContractStatusPill, fDate, fToLocalNumber } from '@web/utils/src';
import arrowTop from '@web/utils/src/assets/icons/functions/arrow-top.svg';
import { ContractStatus } from '@/types';
import { TableCell, TableRow } from '@mui/material';

type Props = {
  contract: PContract;
  handleClick: (contract: PContract) => void;
};

const SingleContract: React.FC<Props> = ({ contract, handleClick }) => {
  const { t } = useTranslation();

  const deliveredAmount = useMemo(() => {
    if (!contract || !contract.lineItems) return '0 / 0';

    const totalDeliveredAmount = contract.lineItems.reduce(
      (acc, item) => acc + (item.deliveredAmount || 0),
      0,
    );

    const totalAmount = contract.lineItems.reduce(
      (acc, item) => acc + (item.amount || 0),
      0,
    );

    return `${fToLocalNumber(totalDeliveredAmount)} / ${fToLocalNumber(
      totalAmount,
    )} ${contract.lineItems[0]?.erpAmountUnit ?? ''}`;
  }, [contract]);

  const expectedDeliveryValue = useMemo(() => {
    const start = contract.expectedDeliveryAt?.start;
    const end = contract.expectedDeliveryAt?.end;
    return `${fDate(start)} - ${fDate(end)}`;
  }, [contract]);

  return (
    <TableRow
      hover
      key={contract.id}
      tabIndex={-1}
      role="checkbox"
      className="relative cursor-pointer"
      onClick={() => handleClick(contract)}
    >
      <TableCell align="left">
        <span className="table-cell text-1-4">{contract.id}</span>
      </TableCell>
      <TableCell align="left">
        <ContractStatusPill status={contract.status as ContractStatus} t={t} />
      </TableCell>
      <TableCell align="left">
        <span className="table-cell text-1-4">{expectedDeliveryValue}</span>
      </TableCell>
      <TableCell align="left">
        <span className="table-cell text-1-4">{contract.erpID}</span>
      </TableCell>
      <TableCell align="left">
        <span className="table-cell text-1-4">{deliveredAmount}</span>
      </TableCell>
      <TableCell className="absolute right-0 h-full flex items-center px-1-0 cursor-pointer opacity-70 hover:opacity-90">
        <ReactSVG src={arrowTop} className="text-white rotate-90 " />
      </TableCell>
    </TableRow>
  );
};

export default SingleContract;
